export default __webpack_public_path__ + "static/media/check-active.ef7c01cf.svg";